const conversationList = [
  {
    title: 'Saying Hello',
    lang: 'ja-JP',
    conversation: [
      {
        role: 'a',
        sentence: 'こんにちは！',
        pronounce: 'Konnichiwa!',
        translate: 'สวัสดี!'
      },
      {
        role: 'b',
        sentence: 'こんにちは！お元気ですか？',
        pronounce: 'Konnichiwa! Ogenki desu ka?',
        translate: 'สวัสดี! สบายดีไหม?'
      },
      {
        role: 'a',
        sentence: 'はい、元気です。あなたは？',
        pronounce: 'Hai, genki desu. Anata wa?',
        translate: 'ค่ะ/ครับ สบายดีค่ะ/ครับ แล้วคุณล่ะ?'
      },
      {
        role: 'b',
        sentence: '私も元気です。ありがとう！',
        pronounce: 'Watashi mo genki desu. Arigatou!',
        translate: 'ฉันก็สบายดี ขอบคุณ!'
      }
    ]
  },
  {
    title: 'Ordering Ramen',
    lang: 'ja-JP',
    conversation: [
      {
        role: 'a',
        sentence: 'いらっしゃいませ！',
        pronounce: 'Irasshaimase!',
        translate: 'ยินดีต้อนรับ!'
      },
      {
        role: 'b',
        sentence: 'ラーメンをお願いします。',
        pronounce: 'Rāmen o onegai shimasu.',
        translate: 'ขอราเม็งหนึ่งที่ค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: 'どのラーメンになさいますか？',
        pronounce: 'Dono rāmen ni nasaimasu ka?',
        translate: 'จะรับราเม็งแบบไหนดีคะ/ครับ?'
      },
      {
        role: 'b',
        sentence: 'しょうゆラーメンをください。',
        pronounce: 'Shouyu rāmen o kudasai.',
        translate: 'ขอราเม็งโชยุค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: 'かしこまりました。少々お待ちください。',
        pronounce: 'Kashikomarimashita. Shou shou omachi kudasai.',
        translate: 'รับทราบค่ะ/ครับ กรุณารอสักครู่.'
      }
    ]
  },
  {
    title: 'At a Convenience Store',
    lang: 'ja-JP',
    conversation: [
      {
        role: 'a',
        sentence: 'いらっしゃいませ！',
        pronounce: 'Irasshaimase!',
        translate: 'ยินดีต้อนรับ!'
      },
      {
        role: 'b',
        sentence: 'このおにぎりはいくらですか？',
        pronounce: 'Kono onigiri wa ikura desu ka?',
        translate: 'โอนิกิรินี้ราคาเท่าไหร่คะ/ครับ?'
      },
      {
        role: 'a',
        sentence: '150円です。',
        pronounce: 'Hyaku gojuu en desu.',
        translate: '150 เยนค่ะ/ครับ.'
      },
      {
        role: 'b',
        sentence: 'じゃあ、これを二つください。',
        pronounce: 'Jaa, kore o futatsu kudasai.',
        translate: 'งั้น ขออันนี้สองชิ้นค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: 'ほかに何かいりますか？',
        pronounce: 'Hoka ni nani ka irimasu ka?',
        translate: 'รับอย่างอื่นเพิ่มไหมคะ/ครับ?'
      },
      {
        role: 'b',
        sentence: 'はい、水もお願いします。',
        pronounce: 'Hai, mizu mo onegai shimasu.',
        translate: 'ค่ะ/ครับ ขอซื้อน้ำด้วยค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: 'かしこまりました。全部で350円です。',
        pronounce: 'Kashikomarimashita. Zenbu de sanbyaku gojuu en desu.',
        translate: 'รับทราบค่ะ/ครับ ทั้งหมด 350 เยนค่ะ/ครับ.'
      },
      {
        role: 'b',
        sentence: 'はい、どうぞ。',
        pronounce: 'Hai, douzo.',
        translate: 'นี่ค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: '500円お預かりします。お釣りは150円です。',
        pronounce: 'Gohyaku en o azukarishimasu. Otsuri wa hyaku gojuu en desu.',
        translate: 'รับเงิน 500 เยนค่ะ/ครับ เงินทอน 150 เยนค่ะ/ครับ.'
      },
      {
        role: 'b',
        sentence: 'ありがとうございます。',
        pronounce: 'Arigatou gozaimasu.',
        translate: 'ขอบคุณค่ะ/ครับ.'
      },
      {
        role: 'a',
        sentence: 'ありがとうございました。またお越しくださいませ！',
        pronounce: 'Arigatou gozaimashita. Mata okoshi kudasaimase!',
        translate: 'ขอบคุณค่ะ/ครับ โอกาสหน้าเชิญใหม่นะคะ/ครับ!'
      }
    ]
  },
  {
    title: 'Hobbies and habits',
    lang: 'en-US',
    conversation: [
      {
        role: 'a',
        sentence: 'What do you usually do in your free time?',
        pronounce: 'What do you usually do in your free time?',
        translate: 'คุณทำอะไรในเวลาว่าง'
      },
      {
        role: 'b',
        sentence: 'I love reading books. How about you?',
        pronounce: 'I love reading books. How about you?',
        translate: 'ฉันอ่านหนังสือ แล้วคุณล่ะ'
      },
      {
        role: 'a',
        sentence: 'I enjoy hiking on weekends. Do you have a favorite book?',
        pronounce: 'I enjoy hiking on weekends. Do you have a favorite book?',
        translate: 'ฉันชอบปีนเขาในวันหยุด แล้วคุณมีหนังสือเล่นโปรดหรือป่าว'
      },
      {
        role: 'b',
        sentence: 'Yes, I do. I really like “To Kill a Mockingbird.” What about you?',
        pronounce: 'Yes, I do. I really like “To Kill a Mockingbird.” What about you?',
        translate: 'ใช่ ฉันมี ฉันชอบ To "Kill a Mockingbird" แล้วคุณล่ะ'
      },
      {
        role: 'a',
        sentence: 'That\'s a great book! I also like painting. It\'s very relaxing.',
        pronounce: 'That\'s a great book! I also like painting. It\'s very relaxing.',
        translate: 'นั่นมั่นเยี่ยมมาก ฉันก็ชอบวาดรูป มันทำให้ฉันผ่านคลาย'
      },
      {
        role: 'b',
        sentence: 'You paint? That\'s cool! Do you have any other hobbies?',
        pronounce: 'You paint? That\'s cool! Do you have any other hobbies?',
        translate: 'คุณวาดรูป มันเจ๋งมาก แล้วคุณมีงานอดิเรกอีกหรือป่าว'
      },
      {
        role: 'a',
        sentence: 'Yes, I also enjoy cooking. Trying out new recipes is fun.',
        pronounce: 'Yes, I also enjoy cooking. Trying out new recipes is fun.',
        translate: 'ใช่ ฉันสนุกกับการทำอาหาร พยายามสุกกับการทำเมนูใหม่ๆ'
      },
      {
        role: 'b',
        sentence: 'Really? Maybe we can cook together sometime!',
        pronounce: 'Really? Maybe we can cook together sometime!',
        translate: 'จริงดิ บางทีเราน่าจะมาทำอาหารร่วมกันนะ'
      },
      {
        role: 'a',
        sentence: 'That sounds like a great idea!',
        pronounce: 'That sounds like a great idea!',
        translate: 'เป็นความคิดที่ดีมาก'
      }
    ]
  }
]

export {
  conversationList
}